import { appRouterPaths } from "@/services/navigation";
import { SignUp } from "@/pages/RegistrationPage/Components/SignUp";
import type { RouteProps } from "react-router-dom";

export const signUpPageRoute: RouteProps = {
  path: appRouterPaths.signUp,
  element: <SignUp />,
};
